import { render, staticRenderFns } from "./MobileModal.vue?vue&type=template&id=139780ca&"
import script from "./MobileModal.vue?vue&type=script&lang=ts&"
export * from "./MobileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports